export enum PepStatus {
  pending = 0,
  noMatch = 1,
  possibleMatch = 2,
  confirmedMatch = 3,
  falsePositive = 4,
}
